// extracted by mini-css-extract-plugin
export default {"errorMsg":"Error_errorMsg__oHp+2","errorBanner":"Error_errorBanner__0KT4-","mobError":"Error_mobError__Gerl5"};